export default "__VITE_ASSET__yr7xOdcf__"